(function () {
    'use strict';

    angular.module('doclr.components.validations', [])
        .directive('hhmmPattern', function () {
            return {
                require: 'ngModel',
                link: function (scope, elm, attrs, ngModelCtrl) {
                    var uurRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

                    var validate = function (value) {
                        if (value === null || value === '' || typeof (value) === "undefined") {
                            ngModelCtrl.$setValidity('hhmmPattern', true);
                            return value;
                        }

                        if (uurRegex.test(value)) {
                            ngModelCtrl.$setValidity('hhmmPattern', true);
                            return value;
                        } else {
                            ngModelCtrl.$setValidity('hhmmPattern', false);
                            return undefined;
                        }
                    };

                    var interpret = function (newValue) {
                        if (!newValue || uurRegex.test(newValue)) {
                            return newValue;
                        }
                        var number = parseInt(newValue.replace(/\D/g, ''), 10);
                        var padded = '' + number;
                        if (number < 10) {
                            padded = '0' + number + '00';
                        } else if (number < 24) {
                            padded = number + '00';
                        } else if (number < 100) {
                            padded = '0' + number + '0';
                        } else if (number < 1000) {
                            padded = '0' + number;
                        }
                        return padded.slice(0, 2) + ':' + padded.slice(2, 4);
                    };

                    elm.bind('blur', function () {
                        scope.$apply(function () {
                            var input = interpret(elm.val());
                            validate(input);
                            ngModelCtrl.$setViewValue(input);
                            ngModelCtrl.$render();
                        });
                    });

                    elm.bind('keyup change', function () {
                        scope.$apply(function () {
                            validate(elm.val());
                        });
                    });

                    scope.$on('$destroy', function () {
                        elm.off();
                    });

                    ngModelCtrl.$formatters.push(validate, interpret);
                }
            };
        })
        .directive('assertAfter', function () {
            return {
                require: 'ngModel',
                link: function (scope, elm, attrs, ngModelCtrl) {
                    var uurRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

                    scope.$watch(attrs.assertAfter, function (newValue, oldValue) {
                        if (newValue !== oldValue) {
                            updateUur(newValue);
                        }
                    });

                    function updateUur(newValue) {
                        var before = moment(newValue, 'HH:mm');
                        var current = moment(ngModelCtrl.$modelValue, 'HH:mm');
                        if (uurRegex.test(newValue) && before.isValid() && uurRegex.test(ngModelCtrl.$modelValue) && current.isValid() && before.isAfter(current)) {
                            ngModelCtrl.$setViewValue(newValue);
                            ngModelCtrl.$render();
                        }
                    }

                    scope.$watch(attrs.assertAfter, function (newValue, oldValue) {
                        if (newValue !== oldValue) {
                            updateUur(newValue);
                        }
                    });

                }
            };
        })
        .directive('assertBefore', function () {
            return {
                require: 'ngModel',
                link: function (scope, elm, attrs, ngModelCtrl) {
                    var uurRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

                    function updateUur(newValue) {
                        var after = moment(newValue, 'HH:mm');
                        var current = moment(ngModelCtrl.$modelValue, 'HH:mm');
                        if (uurRegex.test(newValue) && after.isValid() && uurRegex.test(ngModelCtrl.$modelValue) && current.isValid() && after.isBefore(current)) {
                            ngModelCtrl.$setViewValue(newValue);
                            ngModelCtrl.$render();
                        }
                    }

                    scope.$watch(attrs.assertBefore, function (newValue, oldValue) {
                        if (newValue !== oldValue) {
                            updateUur(newValue);
                        }
                    });
                }
            };
        })
        .directive('dateTimeInterval', function () {
            return {
                scope: {
                    model: '=ngModel',
                    onlyHoursEnabled: '='
                },
                replace: true,
                /*jshint multistr: true */
                template: '<div>\
                                <div class="checkbox" style="margin-bottom: 2px; padding-top: 0">\
                                    <label style="font-weight: normal" ><input type="checkbox" ng-model="model.heleDag" ng-disabled="onlyHoursEnabled"> {{"validation.day" | translate}}</label>\
                                </div>\
                                <div>\
                                    <span style="white-space: nowrap">\
                                        <input ng-model="model.dagVan" class="form-control form-control-inline" jqdatepicker-input doclr-date type="text" class="dagVan" ng-blur="updateTot()" ng-disabled="onlyHoursEnabled">\
                                        <input ng-model="model.uurVan" class="form-control form-control-inline input-short" type="text" class="uurVan" ng-blur="updateTot()" required hhmm-pattern ng-disabled="model.heleDag">\
                                    </span>\
                                    <span class="form-text-inline">{{"partials.adminagenda.afspraaktdetail.labelTimeBetween" | translate}}</span>\
                                    <span style="white-space: nowrap">\
                                        <input ng-model="model.dagTot" class="form-control form-control-inline" jqdatepicker-input doclr-date type="text" class="dagTot" ng-blur="updateVan()" ng-disabled="onlyHoursEnabled">\
                                        <input ng-model="model.uurTot" class="form-control form-control-inline input-short" type="text" class="uurTot" ng-blur="updateVan()" required hhmm-pattern ng-disabled="model.heleDag">\
                                    </span>\
                                </div>\
                            </div>',
                link: function (scope) {
                    function momentVan() {
                        return moment(scope.model.dagVan + ' ' + scope.model.uurVan);
                    }

                    function momentTot() {
                        return moment(scope.model.dagTot + ' ' + scope.model.uurTot);
                    }

                    scope.updateTot = function () {
                        var van = momentVan();
                        var tot = momentTot();
                        if (van.isValid() && tot.isValid() && van.isAfter(tot)) {
                            scope.model.dagTot = scope.model.dagVan;
                            scope.model.uurTot = scope.model.uurVan;
                        }
                    };

                    scope.updateVan = function () {
                        var van = momentVan();
                        var tot = momentTot();
                        if (van.isValid() && tot.isValid() && tot.isBefore(van)) {
                            scope.model.dagVan = scope.model.dagTot;
                            scope.model.uurVan = scope.model.uurTot;
                        }
                    };

                }
            };
        })
        .directive('doclrDate', function () {
            return {
                require: 'ngModel',
                link: function (scope, elm, attrs, ngModelCtrl) {
                    var dateTransformer = function (fromFormat, toFormat) {
                        return function (value) {
                            if (!value) {
                                ngModelCtrl.$setValidity('date', true);
                                return value;
                            }

                            var date = moment(value, fromFormat);
                            var valid = date.isValid() && date.isAfter(moment('1850', 'YYYY'));
                            ngModelCtrl.$setValidity('date', valid);
                            return valid ? date.format(toFormat) : undefined;
                        };
                    };

                    ngModelCtrl.$parsers.push(dateTransformer('DD-MM-YYYY', 'YYYY-MM-DD'));
                    ngModelCtrl.$formatters.push(dateTransformer('YYYY-MM-DD', 'DD-MM-YYYY'));

                    elm.bind('keyup', function (evt) {
                        if (evt.keyCode === 8) {
                            return;
                        }

                        var value = elm.val();
                        var numChars = value.length;
                        if (numChars === 2 || numChars === 5) {
                            value = value + '-';
                            elm.val(value);
                        }
                    });
                }
            };
        })
        .directive('doclrRijksregisternummer', function () {
            return {
                require: 'ngModel',
                link: function (scope, elm, attrs, ngModelCtrl) {

                    var validateRijksregisterNummer = function (n) {

                        if (!n) {
                            return false;
                        }

                        n = n.replace(/[^\d]/g, '');
                        // insz numbers needs to be 11 chars long
                        if (n.length != 11) {
                            return false;
                        }

                        var checkDigit = n.substr(n.length - 2, 2);
                        var modFunction = function (nr) {
                            return 97 - (nr % 97);
                        };

                        var nrToCheck = parseInt(n.substr(0, 9));

                        // first check without 2 (voor 2000)
                        if (modFunction(nrToCheck) == checkDigit) {
                            return true;
                        }

                        // then check with 2 appended for y2k+ births (na 2000)
                        nrToCheck = parseInt('2' + n.substr(0, 9));

                        return (modFunction(nrToCheck) == checkDigit);
                    }

                    function formatSsin(ssinValue) {

                        function addCharAt(str, chara, at) {
                            if (str.length >= at) {
                                return [str.slice(0, at), chara, str.slice(at)].join('');
                            }

                            return str;
                        }

                        //Enkel nummers
                        ssinValue = ssinValue.replace(/[^\d]/g, '');

                        ssinValue = addCharAt(ssinValue, '.', 2);
                        ssinValue = addCharAt(ssinValue, '.', 5);
                        ssinValue = addCharAt(ssinValue, '-', 8);
                        ssinValue = addCharAt(ssinValue, '.', 12);

                        return ssinValue;
                    }

                    elm.bind('keyup', function (evt) {

                        if (evt.keyCode === 8) {
                            return;
                        }

                        var value = elm.val();

                        if (!value) {
                            return;
                        }

                        value = formatSsin(value);
                        elm.val(value);

                    });

                    //For DOM -> model validation
                    ngModelCtrl.$parsers.unshift(function (rijksregisterNummer) {
                        if (!rijksregisterNummer) {
                            if (!ngModelCtrl.$$attr.required) {
                                ngModelCtrl.$setValidity('mod97', true);
                            }
                            return rijksregisterNummer;
                        }
                        var valid = validateRijksregisterNummer(rijksregisterNummer);
                        ngModelCtrl.$setValidity('mod97', valid);
                        return valid ? rijksregisterNummer : undefined;
                    });

                    //For model -> DOM validation
                    ngModelCtrl.$formatters.unshift(function (rijksregisterNummer) {
                        if (!rijksregisterNummer) {
                            return rijksregisterNummer;
                        }
                        var valid = validateRijksregisterNummer(rijksregisterNummer);
                        ngModelCtrl.$setValidity('mod97', valid);
                        return valid ? formatSsin(rijksregisterNummer) : undefined;
                    });

                }
            };
        })
        .directive('tokenStrength', function () {
            return {
                require: 'ngModel',
                link: function (scope, elm, attrs, ngModelCtrl) {

                    var validateToken = function (token) {
                        var isValid = true;
                        if (token.length >= 6) {
                            ngModelCtrl.$setValidity('tokenLengte', true);
                        } else {
                            ngModelCtrl.$setValidity('tokenLengte', false);
                            isValid = false;
                        }

                        if (/\d/.test(token)) {
                            ngModelCtrl.$setValidity('tokenNummer', true);
                        } else {
                            ngModelCtrl.$setValidity('tokenNummer', false);
                            isValid = false;
                        }

                        if (/[a-z]/.test(token)) {
                            ngModelCtrl.$setValidity('tokenKleineLetter', true);
                        } else {
                            ngModelCtrl.$setValidity('tokenKleineLetter', false);
                            isValid = false;
                        }

                        if (/[A-Z]/.test(token)) {
                            ngModelCtrl.$setValidity('tokenGroteLetter', true);
                        } else {
                            ngModelCtrl.$setValidity('tokenGroteLetter', false);
                            isValid = false;
                        }

                        if (!/[^a-zA-Z0-9-._~]/.test(token)) {
                            ngModelCtrl.$setValidity('tokenSpecialeLetters', true);
                        } else {
                            ngModelCtrl.$setValidity('tokenSpecialeLetters', false);
                            isValid = false;
                        }

                        return isValid;
                    };

                    //For DOM -> model validation
                    ngModelCtrl.$parsers.unshift(function (token) {
                        var valid = validateToken(token);
                        return valid ? token : undefined;
                    });

                    //For model -> DOM validation
                    ngModelCtrl.$formatters.unshift(function (token) {
                        var valid = validateToken(token);
                        return valid ? token : undefined;
                    });
                }
            };
        })
        .directive('checkEmailValidation', ['$http', 'praktijkContext', function ($http, praktijkContext) {
            return {
                require: 'ngModel',
                link: function (scope, elem, attrs, ctrl) {
                    elem.on('blur', function () {
                        scope.$apply(function () {
                            if (!praktijkContext.patientenstopZonderLogin) {
                                return;
                            }
                            $http({
                                method: 'POST',
                                url: '/api/public/patient/emailvalidatie',
                                data: {
                                    praktijk_id: praktijkContext.id,
                                    email: elem.val()
                                }
                            }).then(function (response) {
                                ctrl.$setValidity('emailNietGeaccepteerd', response.data > 0);
                                ctrl.nbOfVerified = response.data;
                                ctrl.emailGeinvalideerd = false;
                            });
                        });
                    });
                    elem.on('keyup', function () {
                        if (!praktijkContext.patientenstopZonderLogin) {
                            return;
                        }
                        ctrl.emailGeinvalideerd = true;
                        ctrl.$setValidity('emailNietGeaccepteerd', true);
                    });
                }
            };
        }
        ]);
})();